import { useState } from 'react';
import { RequestPasswordResetRequest, RequestPasswordResetResponse } from '../../../../functions/api/v1/users/reset-password/type';

export const ResetPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setSuccess(false);
        setMessage('');
        setIsLoading(true);

        try {
            const baseUrl = new URL(window.location.href).origin;
            const response = await fetch(`${baseUrl}/api/v1/users/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                } as RequestPasswordResetRequest),
            });

            const data = await response.json() as RequestPasswordResetResponse;

            if (!response.ok) {
                setError(data.message || 'An error occurred. Please try again.');
                return;
            }

            setSuccess(true);
            setMessage(data.message);
        } catch {
            setError('Network error. Please try again later.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F7F8F8] flex items-center justify-center p-4">
            <div className="w-full max-w-md bg-white rounded-lg shadow-md p-8">
                <div className="flex justify-center mb-4">
                    <img src="/logo.webp" alt="Fujiyama Logo" className="h-16" />
                </div>
                <h1 className="text-2xl font-bold text-center text-gray-800 mb-8">
                    Reset Password
                </h1>

                {error && (
                    <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md text-sm">
                        {error}
                    </div>
                )}

                {success ? (
                    <div className="mb-4 p-4 bg-green-100 text-green-700 rounded-md">
                        <p className="font-medium mb-2">Password reset email sent</p>
                        <p className="text-sm">{message}</p>
                        <p className="text-sm mt-4">Please click the link in the email to set a new password.</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                Email Address
                            </label>
                            <input
                                id="email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="example@example.com"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className={`w-full py-3 px-4 text-white rounded-md ${isLoading
                                ? 'bg-blue-400 cursor-not-allowed'
                                : 'bg-blue-600 hover:bg-blue-700'
                                } transition-colors duration-200`}
                        >
                            {isLoading ? 'Processing...' : 'Send Reset Link'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ResetPasswordPage;